import styled from "styled-components";
import { rgba } from "polished";
import type { PropsWithChildren } from "react";

const WrapperPartial = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => rgba(props.theme.colors.dark000, 0.7)};
`;

const Lights = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const Wrapper = styled(WrapperPartial)`
  backdrop-filter: blur(0);
  opacity: 0;
  pointer-events: none;
  transition: opacity 300ms;
  ${Lights} {
    opacity: 0;
    transition: opacity 300ms;
  }

  &[data-visible="true"] {
    backdrop-filter: blur(6px);
    opacity: 1;
    pointer-events: all;
    transition: opacity 400ms, backdrop-filter 400ms;

    ${Lights} {
      opacity: 0.6;
      transition: opacity 300ms 100ms;
    }
  }

  ${(props) => props.theme.medias.maxXXS} {
    transition-duration: 0ms;

    ${Lights} {
      transition-duration: 0ms;
    }

    &[data-visible="true"] {
      transition-duration: 0ms;

      ${Lights} {
        transition-duration: 0ms;
      }
    }
  }
`;

interface Props {
  className?: string;
  isBacklit?: boolean;
  isOpen: boolean;
  onClick?: () => void;
}

function Backdrop({
  className,
  isBacklit = false,
  isOpen = false,
  onClick,
}: PropsWithChildren<Props>) {
  return (
    <Wrapper className={className} data-visible={isOpen} onClick={onClick}>
      {isBacklit && <Lights />}
    </Wrapper>
  );
}

export default Backdrop;
